import React from "react";
import { NewCatalogueStep } from "@/components/catalogue/NewCatalogueStep";
import { useAuth } from "@/context/AuthContext";

export function RequireAdminOnly({ children }) {
  const { user } = useAuth();
  if (user?.is_super || (user?.roles || []).includes("admin")) return children;
  return <div className="p-10 text-center text-slate-500" data-testid="bundle-migration-denied">New catalogue setup is restricted to administrators.</div>;
}

export default function BundleMigrationPage() {
  return (
    <div className="px-6 lg:px-8 pt-4 pb-8" data-testid="bundle-migration-page">
      <h1 className="ted-page-title">New catalogue setup</h1>
      <p className="ted-subtle mt-1 mb-4">The new /shop/ products and bundles are the current accessories catalogue. Old accessories are hidden from selection only; historical jobs, orders and invoices are never changed.</p>
      <NewCatalogueStep />
    </div>
  );
}
